import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { getAuthUser } from "../../redux/auth";

const NotificationPreferencesRedirect = () => {
  const user = useSelector(getAuthUser);
  if (!user?.id) return <Navigate to="/signin" replace />;
  return <Navigate to={`/users/${user.id}?tab=notifications`} replace />;
};

export default NotificationPreferencesRedirect;
